<template>
  <div class="checkbox" :class="{ 'custom-icons': customIcons }">
    <v-checkbox v-bind="$props" v-on="checkboxListeners" />

    <div v-if="customIcons" class="custom-icon-overlay" @click="toggle">
      <component
        v-if="iconComponent"
        :is="iconComponent"
        class="d-flex checkbox-icon"
        @mousedown.stop
      />

      <Img
        v-else
        class="d-flex checkbox-icon"
        :width="iconSize"
        :src="getImgWithExt([iconPath, value ? trueIcon : falseIcon, 'svg'])"
      />
    </div>
  </div>
</template>

<script>
import Image from '@/mixins/Image'

export default {
  name: 'checkbox',
  mixins: [Image],
  props: {
    bgDefault: Boolean,
    color: String,
    dark: Boolean,
    disabled: Boolean,
    hint: String,
    inputValue: Boolean,
    label: String,
    large: Boolean,
    value: Boolean,
    rules: Array,
    customIcons: {
      type: Boolean,
      default: false
    },
    iconComponent: {
      type: [Object, String],
      default: null
    },
    trueIcon: {
      type: String,
      default: 'check-circle-green'
    },
    falseIcon: {
      type: String,
      default: 'plus-circle-grey'
    },
    iconSize: {
      type: Number,
      default: 24
    },
    iconPath: {
      type: String,
      default: 'icons'
    }
  },
  computed: {
    checkboxListeners () {
      const vm = this
      return Object.assign({}, this.$listeners, {
        change (event) {
          vm.$emit('change', event)
        }
      })
    }
  },
  methods: {
    toggle() {
      this.$emit('change', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox {
    display: flex;
    align-items: center;
    position: relative;

    ::v-deep .v-input {
      padding: 0;
      margin: 0;

      .v-icon {
        font-size: 23px !important;
      }
    }

    &.custom-icons {
      ::v-deep .v-input {
        opacity: 0;
        pointer-events: none;
      }

      .custom-icon-overlay {
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .checkbox-icon {
          transition: transform 0.2s ease;
        }

        &:hover .checkbox-icon {
          transform: scale(1.1);
        }
      }
    }
  }
</style>
